import {Stack, styled} from '@mui/material';

const StyledStack = styled(Stack)`
	padding: 8px 8px 8px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding: 8px 16px 8px;
	}
`;

export {StyledStack};
